import{e as n,m as e}from"./chunk-HBP5N4FR.js";function s(){return typeof sessionStorage!="undefined"}var o=n(()=>{e()});export{s as a,o as b};
//# sourceMappingURL=chunk-RALSJ7UN.js.map
